import SvgIcon, { SvgIconProps } from '../components/SvgIcon';

interface Props extends SvgIconProps {}

const BluetoothIcon = ({ ...props }: Props) => {
  return (
    <SvgIcon
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.9016 14.9998L21.5683 10.5782C21.7133 10.4425 21.8261 10.2761 21.8985 10.0912C21.9708 9.90625 22.0008 9.70746 21.9862 9.50942C21.9717 9.31137 21.913 9.1191 21.8144 8.94671C21.7158 8.77431 21.5799 8.62618 21.4166 8.51318L15.9683 4.74485C15.764 4.6018 15.5244 4.51748 15.2755 4.50102C15.0266 4.48457 14.778 4.53662 14.5566 4.65151C14.3422 4.76283 14.1618 4.92999 14.0345 5.13533C13.9071 5.34068 13.8376 5.5766 13.8333 5.81818V13.0515L10.1116 8.38485C9.91051 8.1435 9.62175 7.99193 9.30887 7.96349C8.996 7.93505 8.68464 8.03206 8.4433 8.23318C8.20195 8.4343 8.05038 8.72306 8.02194 9.03594C7.9935 9.34881 8.09051 9.66017 8.29163 9.90151L12.34 14.9998L8.25663 20.1682C8.06587 20.41 7.97844 20.7173 8.01341 21.0233C8.04838 21.3293 8.20291 21.609 8.4433 21.8015C8.656 21.9454 8.91026 22.0152 9.16663 21.9998C9.34187 21.999 9.51467 21.9588 9.67221 21.882C9.82975 21.8053 9.96798 21.694 10.0766 21.5565L13.8333 16.8198V24.1582C13.8364 24.5151 13.9803 24.8563 14.2338 25.1076C14.4872 25.3589 14.8297 25.4999 15.1866 25.4998C15.4662 25.5009 15.7393 25.4153 15.9683 25.2548L21.3816 21.5448C21.543 21.4308 21.6777 21.283 21.7764 21.1118C21.8751 20.9406 21.9355 20.75 21.9533 20.5532C21.9686 20.358 21.9411 20.1618 21.8726 19.9784C21.804 19.795 21.6962 19.6288 21.5566 19.4915L16.9016 14.9998ZM16.1666 7.71985L19.0833 9.73818L16.1666 12.4915V7.71985ZM16.1666 22.2915V17.5432L19.0483 20.3198L16.1666 22.2915Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default BluetoothIcon;
